import { render, staticRenderFns } from "./NftHistoryAddress.vue?vue&type=template&id=74a73962"
import script from "./NftHistoryAddress.vue?vue&type=script&lang=js"
export * from "./NftHistoryAddress.vue?vue&type=script&lang=js"
import style0 from "./NftHistoryAddress.vue?vue&type=style&index=0&id=74a73962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports